import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import Stream from 'flarum/common/utils/Stream';
import Search from "flarum/forum/components/Search";
import ZSDataUserPage from "./components/ZS/ZSDataUserPage";
import SCPDataUserPage from "./components/SCP/SCPDataUserPage";
import ZSRankPage from "./components/ZS/ZSRankPage";
import SCPRankPage from "./components/SCP/SCPRankPage";
import ZSRoundPage from "./components/ZS/ZSRoundPage";
import SCPRoundPage from "./components/SCP/SCPRoundPage";
import ZSDataPlayerPage from "./components/ZS/ZSDataPlayerPage";
import SCPDataPlayerPage from "./components/SCP/SCPDataPlayerPage";
import SCPServerStatisticsPage from "./components/SCP/SCPServerStatisticsPage";
import ZSServerStatisticsPage from "./components/ZS/ZSServerStatisticsPage";
import SignUpModal from "flarum/forum/components/SignUpModal";

import extendForum from "./extenders/Forum";
import extendModal from "./extenders/Modal";
import extendUser from "./extenders/User";

app.initializers.add("rhodes-island", function(app) {
  app.data.steamProfiles = {};

  app.routes["user.zs_data"] = {path: "/u/:username/zs-data", component: ZSDataUserPage}
  app.routes["user.scp_data"] = {path: "/u/:username/scp-data", component: SCPDataUserPage}
  app.routes["player.zs_data"] = {path: "/player/:steamid", component: ZSDataPlayerPage}
  app.routes["player.scp_data"] = {path: "/player/:steamid/scp-data", component: SCPDataPlayerPage}
  app.routes["server.zs_stat"] = {path: "/statistics", component: ZSServerStatisticsPage}
  app.routes["server.scp_stat"] = {path: "/statistics/scp", component: SCPServerStatisticsPage}
  app.routes["server.rank"] = {path: "/rank", component: ZSRankPage}
  app.routes["server.rank.scp"] = {path: "/rank/scp", component: SCPRankPage}
  app.routes["server.rounds"] = {path: "/rounds", component: ZSRoundPage}
  app.routes["server.rounds.scp"] = {path: "/rounds/scp", component: SCPRoundPage}

  extendForum();
  extendModal();
  extendUser();

  setTimeout(() => {
    if ((app.forum.data.attributes as any).tokenRegisterPayload) {
      const tipAlert = app.alerts.show({
        type: "success",
        dismissible: false
      }, app.translator.trans("rhodes-island.forum.log_in.auth_token_register_tip"));
      app.modal.show(SignUpModal, {
        ...(app.forum.data.attributes as any).tokenRegisterPayload,
        onremove: function() {
          app.alerts.dismiss(tipAlert);
        }
      });
    }
  });

  // @ts-ignore
  Search.MIN_SEARCH_LEN = 2;
});

app.initializers.add("rhodes-island-nickname-extender", () => {
  extend(SignUpModal.prototype, "oninit", function() {
    (this as any).nickname = Stream(this.attrs.nickname || this.attrs.username || '');
  });
}, -1);
